import { gql } from '@apollo/client'
import productsFieldsQuery from '../../commons/fields/products'
import linkedProductsFieldsQuery from '../../commons/fields/linkedProducts'
import promotionsFieldsQuery from '../../commons/fields/promotions'

/**
 * Get catalog fields
 * @internal
 */
export const catalogFieldsQuery: string = `
  category
  priority
  productsPrices {
    ${productsFieldsQuery}
  }
 `

/**
 * Get's the string for `catalog` query.
 * This query gets all existing items in the catalog.
 * @internal
 */
const getCatalogQuery = gql`
  query Catalog(
      $catalogStorefrontName: String!,
      $catalogSessionId: String!,
      $categoryName: String,
      $pagination: PaginationInput,
      $totalPromotionsSessionId: ID!
      $groupCategories: Boolean
      $showChildrenCategories: Boolean
      $showHiddenCategories: Boolean
    ) {
    catalog(
      storefrontName: $catalogStorefrontName,
      sessionUid: $catalogSessionId,
      category: $categoryName,
      pagination: $pagination,
      groupCategories: $groupCategories
      showChildrenCategories: $showChildrenCategories
      showHiddenCategories: $showHiddenCategories
    ) {
      category
      priority
      parentId
      productsPrices {
        ${productsFieldsQuery}
        ${linkedProductsFieldsQuery}
      }
    }
    getTotalPromotions(storefrontName: $catalogStorefrontName, sessionUid: $totalPromotionsSessionId) {
      ${promotionsFieldsQuery}
    }
  }
`

/**
 * One category's products, for `refreshCatalog`'s read of a category loaded
 * past its first page (COM-1520). The `catalog` field with the arguments
 * load-more sends, and only what that read keeps: each entry's name and
 * parent, by which it is picked out, and its products with the same
 * selection as `getCatalogQuery`, linked products included, so they cast as
 * the first-page read's do. No `getTotalPromotions`: the first-page read
 * answers that once per refresh.
 * @internal
 */
export const getCategoryProductsQuery = gql`
  query CategoryProducts(
      $catalogStorefrontName: String!,
      $catalogSessionId: String!,
      $categoryName: String,
      $pagination: PaginationInput,
      $groupCategories: Boolean
    ) {
    catalog(
      storefrontName: $catalogStorefrontName,
      sessionUid: $catalogSessionId,
      category: $categoryName,
      pagination: $pagination,
      groupCategories: $groupCategories
    ) {
      category
      parentId
      productsPrices {
        ${productsFieldsQuery}
        ${linkedProductsFieldsQuery}
      }
    }
  }
`

export default getCatalogQuery
